<template>
  <div class="not-found-container">
    <h1 class="not-found-title">
      404
    </h1>
    <p class="not-found-message">
      Page Not Found
    </p>
    <router-link 
      to="/userprofile" 
      class="not-found-link"
    >
      Go to Home
    </router-link>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}

.not-found-title {
  font-size: 6rem;
  color: #b71c1c;
  margin-bottom: 0.5em;
}

.not-found-message {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1.5em;
}

.not-found-link {
  color: #1976d2;
  text-decoration: underline;
  font-size: 1.1rem;
  transition: color 0.2s;
}

.not-found-link:hover {
  color: #0d47a1;
}
</style>
